<app-modal-basic #modalConsulta dialogClass="modal-lg" (closed)="closed.emit()">
  <div class="app-modal-header">
    <h4 class="modal-title text-center">Notas Fiscais</h4>
  </div>
  <div class="app-modal-body">
    <div class="row">
      <div class="col-sm-12">
        <app-dim-datatable
          *ngIf="(notas.items && notas.items.length > 0) || loading['table']"
          [loading]="loading['table']"
          [selectable]="true"
          [selecionados]="selecionados"
          [columns]="colunas"
          [data]="notas.items"
          [totalItems]="notas.totalItems"
          [currentPage]="notas.pageIndex"
          [rowsOnPage]="10"
          (sorting)="onSort($event)"
          (pageChanged)="onSort($event)"
        ></app-dim-datatable>
        <p
          *ngIf="!((notas.items && notas.items.length > 0) || loading['table'])"
          class="mt-2 mb-4"
        >
          Nenhuma nota fiscal por conta e ordem encontrada para o cliente selecionado.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button
          class="btn btn-primary"
          (click)="carregarItens()"
          [disabled]="loading['itens'] || selecionados.length === 0"
        >
          <app-loading
            icone="ti ti-new-window"
            [loading]="loading['itens']"
            texto="Carregar itens"
          ></app-loading>
        </button>
        <button class="btn btn-danger" (click)="closed.emit()">
          <i class="ti ti-close"></i> Cancelar
        </button>
      </div>
    </div>
  </div>
</app-modal-basic>
